import {
    ConfigSettings, CurrencySettings, LicenseSettings, LocationComponentSettings, MapSettings, SettingsRegistry,
    UserSettings
} from "@mcleod/core";
import { PortalGeneralSettings } from "./PortalGeneralSettings";
import { PortalCompanySettings } from "./PortalCompanySettings";
import { PortalDriverSettings } from "@mcleod/portal-driver";
import { PortalCarrierSettings } from "@mcleod/portal-carrier";
import { PortalCustomerSettings } from "@mcleod/portal-customer";
import { PortalFactoringSettings } from "@mcleod/portal-factoring";

export class PortalsSettingsInitializer {
    public initialize() {
        const settingsRegistry = SettingsRegistry.get();
        settingsRegistry.register(
            new ConfigSettings(),
            new CurrencySettings(),
            new LicenseSettings(),
            new LocationComponentSettings(),
            new MapSettings(),
            new PortalCarrierSettings(),
            new PortalCompanySettings(),
            new PortalCustomerSettings(),
            new PortalDriverSettings(),
            new PortalFactoringSettings(),
            new PortalGeneralSettings(),
            new UserSettings()
        );
        settingsRegistry.settingsRoot = "portal/";
    }
}
